import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CertificatePaymentDTO,
  PaymentCertReportsRequestDTO,
  PaymentCertReportsResponseDTO,
} from '../model/payment-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonDataDTO } from '@app/requests/model/combos-model';

@Injectable()
export class PaymentCertApi {
  constructor(readonly _http: HttpClient) {}

  registerPayment(request: CertificatePaymentDTO): Observable<CommonDataDTO> {
    return this._http.post<CommonDataDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlPaymentCertRegister,
      request
    );
  }

  reportPayment(request: PaymentCertReportsRequestDTO): Observable<PaymentCertReportsResponseDTO> {
    return this._http.post<PaymentCertReportsResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlPaymentCertReport,
      request
    );
  }

  registerPaymentCert(request: CertificatePaymentDTO) {
    return new Promise<CommonDataDTO>((resolve, reject) => {
      this.registerPayment(request).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }

  getPaymentCertReport(request: PaymentCertReportsRequestDTO) {
    return new Promise<PaymentCertReportsResponseDTO>((resolve, reject) => {
      this.reportPayment(request).subscribe(
        (data) => (data ? resolve(data) : reject(data)),
        (error) => reject(error)
      );
    });
  }
}
